<template>
  <el-dialog
      custom-class="dialog-container"
      :title="setId?'修改题目':'新增题目'"
      :visible.sync="casedialogDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :lock-scroll="true"
      width="70%"
      center>
    <el-form :model="basicsForm" :rules="rules" ref="basicsForm" label-width="100px">
      <el-form-item label="科目" prop="subject_first_id">
        <el-select v-model="basicsForm.subject_first_id" placeholder="请选择科目" :disabled="setBankState"
                   style="width: 100%">
          <el-option v-for="item in subjectFirsts" :key="item.id" :label="item.name"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="试题类别" prop="question_type_id">
        <el-select v-model="basicsForm.question_type_id"
                   filterable allow-create
                   :disabled="setBankState"
                   placeholder="请选择试题类别(新增类型输入后选择即可)"
                   @change="halsType"
                   style="width: 100%">
          <el-option v-for="item in subjectTypes" :key="item.id" :label="item.name"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="题目" prop="title">
        <el-input v-model="basicsForm.title" placeholder="请输入题目"></el-input>
      </el-form-item>
      <el-form-item label="案例内容" prop="content">
        <VueUditorWrap v-model="basicsForm.content" :config="myConfig"></VueUditorWrap>
      </el-form-item>

      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('basicsForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('basicsForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {examPracticeAdd, examSubject, questionTypeList, questionTypeAdd} from "@/api/projectOffice";
import {bdEditConfig} from "@/tools/utils";
import VueUditorWrap from 'vue-ueditor-wrap'
export default {
  name: "caseDialog",
  components: {VueUditorWrap},
  props: {
    casedialogDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setBankId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {

    return {
      subjectFirsts: [],
      subjectTypes: [],
      basicsForm: {
        subject_first_id: '',
        question_type_id: '',
        title: '',
        content: '',
      },
      rules: {
        subject_first_id: [{required: true, message: '请选择科目', trigger: 'change'}],
        question_type_id: [{required: true, message: '请选择试题类别', trigger: 'change'}],
        answer: [{required: true, message: '请选择答案', trigger: 'change'}],
        title: [
          {required: true, message: '请输入题目', trigger: 'blur'},
        ],
        content:[ {required: true, message: '请输入案例内容', trigger: 'blur'},]
      },
      myConfig: bdEditConfig()
    }
  },
  computed: {
    setBankState() {
      return this.setBankId === 0 && !this.$route.query.subject ? false : true
    }
  },
  created() {
    if(this.$route.query.subject) {
      this.basicsForm.subject_first_id = Number(this.$route.query.subject)
      this.basicsForm.question_type_id =  Number(this.$route.query.type)
    }
    this.init()
    this.typeChange()
  },
  methods: {
    async init() {
      let _first = await examSubject(
          1,
          10000,
          1,
          1
      );
      this.subjectFirsts = _first.data.list;
      let _type = await questionTypeList(2);
      this.subjectTypes = _type.data;
    },
    halsType(val) {
      let _arr = []
      this.subjectTypes.map(item => {
        _arr.push(item.id)
      })
      if (_arr.indexOf(val) === -1) {
        this.addTypes(val)
      }
    },
    async addTypes(val) {
      let _data = await questionTypeAdd(val, 2)
      await this.init()
      this.basicsForm.question_type_id = Number(_data.data.id)

    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await examPracticeAdd(
          this.setId ? this.setId : '',
          this.basicsForm.subject_first_id,
          this.basicsForm.question_type_id,
          this.basicsForm.content,
          this.basicsForm.title,
      );
      this.$message.success(_state.msg);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    },

    //类型改变
    typeChange() {
      let position = Number(this.basicsForm.type) === 3 ? 2 : 4
      this.basicsForm.selectValue = []
      Number(this.basicsForm.type) === 2 ? this.basicsForm.answer = [] : this.basicsForm.answer = ''
      for (let index = 0; index < position; index++) {
        this.basicsForm.selectValue.push({
          select_name: ''
        });
      }
    },
    //添加题目
    addlSelect(item, index) {
      console.log(item)
      this.basicsForm.selectValue.push({
        select_name: ''
      });
    },
    //删除题目
    delSelect(item, index) {
      console.log(item)
      if (index !== -1) {
        this.basicsForm.selectValue.splice(index, 1)
      }
    }
  },
  watch: {
    setItem() {
      this.basicsForm = {
        subject_first_id: this.setItem.subject_first_id ? this.setItem.subject_first_id : '',
        question_type_id: this.setItem.question_type_id ? this.setItem.question_type_id : '',
        title: this.setItem.title ? this.setItem.title : '',
        content: this.setItem.content ? this.setItem.content : '',
      };
    },
    casedialogDialog(){
      if(this.casedialogDialog && this.$route.query.subject) {
        this.basicsForm.subject_first_id = Number(this.$route.query.subject)
        this.basicsForm.question_type_id =  Number(this.$route.query.type)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-container {
  overflow-y: scroll;
}

.input-container {
  .input-tag {
    width: 50px;
    text-align: center;
  }

  .el-input {
    width: 300px;
    margin-right: 20px;
  }
}
</style>